// extracted by mini-css-extract-plugin
var _1 = "BundleSelectModal__levelP--OfVzm";
var _2 = "BundleSelectModal__link--sIO58 OfficeGeneral__inlineLink--J2Xk5 OfficeGeneral__inlineLinkBase--ofwQY OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _3 = "BundleSelectModal__subtitle--A6kUP OfficeGeneral__robotoSlab--GdBSw OfficeGeneral__robotoMedium--itFSf CoreGeneral__robotoMedium--xrjYk";
export { _1 as "levelP", _2 as "link", _3 as "subtitle" }
